import { html, render } from "lit-html";
import Input from "../engine/input";
import { Commands } from "../engine/commands";

class PauseDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".dialog");
    this.isDirty = true;
  }

  activate(context) {
    this.showWarning = false;
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    this.dialog.classList.add("is-alert");
    this.dialog.classList.add("pause-dialog");
    render(this.getDialogTemplate({ ...context, showWarning: false }), this.dialog);
    this.activateNavFocus();
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
    this.dialog.classList.remove("is-alert");
    this.dialog.classList.remove("pause-dialog");
  }

  reactivate(context) {
    this.activate(context);
  }

  activateNavFocus() {
    this.focusedButton = 0;
    this.nav = this.dialog.querySelectorAll("button");
    this.nav[this.focusedButton].focus();
  }

  nextNavFocus() {
    this.focusedButton = (this.focusedButton + 1) % this.nav.length;
    this.nav[this.focusedButton].focus();
  }

  prevNavFocus() {
    this.focusedButton = ((this.focusedButton - 1) + this.nav.length) % this.nav.length;
    this.nav[this.focusedButton].focus();
  }

  selectMenuButton(el) {
    if (el.matches("button.button-ok")) {
      return Commands.HideDialog;
    } else if (el.matches("button.button-controls")) {
      this.deactivate({});
      return Commands.ShowControls;
    } else if (el.matches("button.button-quit")) {
      if (this.showWarning == false) {
        this.showWarning = true;
        render(this.getDialogTemplate({ showWarning: true }), this.dialog);
      } else {
        return Commands.QuitGame;
      }
    }
  }

  handleClick(ev) {
    if (!this.dialog.contains(ev.target)) return Commands.HideDialog;
    return this.selectMenuButton(ev.target);
  }

  handleInput(input) {
    switch (input) {
      case Input.MoveDown:
      case Input.MoveRight:
      case Input.FocusRight:
        this.nextNavFocus();
        break;
      case Input.MoveUp:
      case Input.MoveLeft:
      case Input.FocusLeft:
        this.prevNavFocus();
        break;
      case Input.Ok:
        return this.selectMenuButton(this.nav[this.focusedButton]);
    }
  }

  handleRightClick() {
    return;
  }

  getDialogTemplate(context) {
    return html`
      <h2 class="pause-title">Caldera</h2>
      <p class="pause-confirmation" ?data-visibility=${context.showWarning}>
        This will reset your progress without saving. Are you sure?
      </p>
      <nav class="pause-menu">
        <button class="button-quit">Main Menu</button>
        <button class="button-controls">Controls</button>
        <button class="button-ok">Continue</button>
      </nav>
    `;
  }

  render(stage) {
    return;
  }
}

export default PauseDialog;
